import React, { useEffect, useRef, useState } from "react";
import ClientLayoutWithOutHeader from "../../client/components/layout/ClientLayoutWithOutHeaderForTeenPatti";
import TpStudioHeader from "../../client/tp-studio/tp-studio-header";
import TPStudioSidebar from "../../client/tp-studio/TPStudioSidebar";
import TpStudioLoader from "../../client/tp-studio/tp-studio-loader";
import TPPopUpBetSlip from "./teenpatti_casino_betslip_popup.jsx";
import "../../../assets/topstudio/styles/CardsSprite.css";

import spriteUrl from "../../../assets/topstudio/styles/svg/sprite.css-d6f47756.svg";

import "../../../assets/topstudio/styles/color-game.css";

import useSocket from "../../../hooks/useSocket";
import BetfairCasinoBetslipWeb from "../betfair-games/betfair_casino_betslip_web";
import { isMobile } from "react-device-detect";
import axiosInstance from "../../../utils/axiosInstance";
import Teenpattit20Result from "../../client/tp-studio/tp-result/Teenpattit20-Result.jsx";

import { useDispatch, useSelector } from "react-redux";
import { setUserData } from "../../../store/userSlice";
import confetti from "canvas-confetti";
import ColorGameResult from "./tp-result/ColorGameResult.jsx";
import Volume from "./Volume";

export default function ColorGame() {
  const dispatch = useDispatch();
  const [displayLoader, setDisplayLoader] = useState(true);
  const [showBetSlipPopup, setShowBetSlipPopup] = useState(false);
  const [betButtonShow, setBetButtonShow] = useState(true);
  const [betButtonShowLoaderShow, setButtonShowLoaderShow] = useState(false);
  const [activeTabIndex, setActiveTabIndex] = useState(1);
  const [resultList, setResultList] = useState([]);

  const [showBetSlip, setShowBetSlip] = useState(false);
  const [placeBetObject, setPlaceBetObject] = useState({});
  const [betErrorMessageObj, setBetErrorMessage] = useState({});
  const [betList, setBetList] = useState([]);
  const [totalBets, setTotalBets] = useState(0);
  ///
  const { data, isConnected } = useSocket({
    marketId: null,
    mtype: "virtual",
    type: "bigsmall_virtual"
  });

  const sessionUser = useSelector((s) => s.userStore.data);
  const updateUserData = async (userData) => {
    if (!userData || !sessionUser) return;
    await dispatch(
      setUserData({
        ...sessionUser,
        fname: userData.fname ?? sessionUser.fname,
        uname: userData.uname ?? sessionUser.uname,
        bz_balance: userData.bz_balance ?? sessionUser.bz_balance,
        opin_bal: userData.opin_bal ?? sessionUser.opin_bal,
        user_role: sessionUser.user_role,
        _id: sessionUser._id
      })
    );
  };

  const payload = data?.data?.data;
  const payloadResult = data?.data?.result;
  //console.log("Socket data:", data);

  let b4 = 0;
  let l1 = 0;
  let l2 = 0;
  let l3 = 0;
  let l4 = 0;

  let lastResult = null;

  const [roundId, setRoundId] = useState("");
  const [eventStatus, setEventStatus] = useState("");
  const [timeLeftGame, setTimeLeftGame] = useState("");
  const [suspend1, setSuspend1] = useState("");
  const [b1, setB1] = useState(0);
  const [b2, setB2] = useState(0);
  const [b3, setB3] = useState(0);
  const [profileData, setProfileData] = useState(null);

  // Winner animation state
  const [showWinnerOverlay, setShowWinnerOverlay] = useState(false);
  const [winnerText, setWinnerText] = useState("");
  const canvasRef = useRef(null);
  const lastStatusRef = useRef("");
  const winTimerRef = useRef(null);

  useEffect(() => {
    if (!payload) return;

    setDisplayLoader(false);

    let betfairOdds = payload;
    updateUserData(data?.user);
    setRoundId(betfairOdds?.evt_id);
    setEventStatus(betfairOdds?.evt_status);

    let timeLeft = betfairOdds?.left_time;
    if (timeLeft == 1) {
      timeLeft = 0;
    }
    timeLeft = parseInt(timeLeft);
    setTimeLeftGame(timeLeft);
    setSuspend1(betfairOdds?.suspend1);

    setB1(betfairOdds?.b1);
    setB2(betfairOdds?.b2);
    setB3(betfairOdds?.b3);
  }, [payload]);

  useEffect(() => {
    if (!payloadResult) return;

    if (payloadResult !== "") {
      //console.log("payloadResult->", payloadResult);
      setResultList([]);
      setResultList(Array.isArray(payloadResult) ? payloadResult : []);
    }
  }, [payloadResult]);

  const showBetfairBetSlip = (bettype, teamname, price) => {
    let placeBetObject = {
      amount: 0,
      catmid: "",
      market_type: "m",
      game_name: "bigsmall_virtual"
    };
    placeBetObject.catmid = roundId;
    //console.log(placeBetObject);
    placeBetObject.odds = price;
    placeBetObject.teamname = teamname;
    placeBetObject.bettype = bettype;
    placeBetObject.game_type = 7;

    setPlaceBetObject(placeBetObject);
    //console.log("isMobile: ", isMobile);
    if (isMobile) {
      setShowBetSlipPopup(true);
    } else {
      setShowBetSlip(true);
    }
    //showBetfairSlipStatus = true;
  };

  const closeBetSlipMobile = () => {
    setShowBetSlipPopup(false);
    setBetErrorMessage({});
  };

  const fetchProfile = async () => {
    try {
      const { data } = await axiosInstance.get("/profile");
      setProfileData(data);
    } catch (error) {
      console.log("Failed to load profile data:", error);
    }
  };

  const activeTab = async (tab1) => {
    setActiveTabIndex(tab1);
  };

  const closeBetSlip = () => {
    setShowBetSlip(false);
  };

  const placeBet = async (amount, profit) => {
    placeBetObject.amount = amount;
    if (profit) {
      placeBetObject.profit = profit;
    } else {
      placeBetObject.profit = 0;
    }

    try {
      const response = await axiosInstance.post(
        "/bigsmall-virtual",
        placeBetObject
      );
      //console.log(response);
      if (
        response.data !== undefined &&
        response.data !== null &&
        response.data.status !== undefined &&
        response.data.status !== null
      ) {
        let messageObj = {};
        if (response.data.status) {
          messageObj.status = true;
        } else {
          messageObj.status = false;
        }
        messageObj.message = response.data.message;
        setBetErrorMessage(messageObj);
        getBook();
        setShowBetSlipPopup(false);
        //getPlacedBets();
      }
    } catch (error) {
      if (error.response.data !== undefined && error.response.data !== null) {
        if (
          error.response.data.status !== undefined &&
          error.response.data.status !== null &&
          error.response.data.status === false
        ) {
          let errorMessage = error.response.data.message;
          let messageObj = {};
          messageObj.status = false;
          messageObj.message = errorMessage;
          setBetErrorMessage(messageObj);
        }
      }
    }
  };

  const getBook = async () => {
    let bookObject = {};
    bookObject.roundId = roundId; // roundId;
    bookObject.game_type = "bigsmall-virtual";
    //console.log(roundId);
    const response = await axiosInstance.post("/tp20-book", bookObject);
    //console.log("response->", response.data);
    ///
    let bet_list = response.data.bets_list;

    if (bet_list.length > 0) {
      setTotalBets(bet_list.length);
      setBetList(bet_list);
    } else {
      setBetList([]);
    }

    ///
    return response;
  };

  useEffect(() => {
    fetchProfile();
  }, []);

  useEffect(
    (roundId) => {
      getBook();
    },
    [roundId]
  ); // Empty dependency array
  /// place bet ///
  /////
  const [open, setOpen] = useState(false);

  const SUITS = ["S", "H", "D", "C"]; // Spades, Hearts, Diamonds, Clubs
  const RANKS = [
    "A",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
    "10",
    "J",
    "Q",
    "K"
  ];
  const SUIT_BASE = { S: 0, H: 13, D: 26, C: 39 };

  function spriteIndexForCard({ suit, rank }) {
    const base = SUIT_BASE[suit];
    const rankIdx = RANKS.indexOf(rank);
    return base + rankIdx;
  }
  function classForCard(card) {
    const idx = spriteIndexForCard(card);
    return `open_cardTP sprite-card-chs-card svg-card_simple_${idx}-dims d-card RSMImageView2 svg-card_simple_${idx}`;
  }

  /** ---- Deck + helpers ---- **/
  function buildDeck() {
    const deck = [];
    for (const s of SUITS)
      for (const r of RANKS) deck.push({ suit: s, rank: r });
    return deck;
  }
  function shuffle(array) {
    const a = array.slice();
    for (let i = a.length - 1; i > 0; i--) {
      const j = (Math.random() * (i + 1)) | 0;
      [a[i], a[j]] = [a[j], a[i]];
    }
    return a;
  }

  /** ---- State ---- **/
  const DEAL_MS = 1000; // one card every 3s
  const [shoe, setShoe] = useState(() => shuffle(buildDeck()));
  const [playerA, setPlayerA] = useState([]); // Player A hand
  const [playerB, setPlayerB] = useState([]); // Player B hand
  const [step, setStep] = useState(0); // 0..6 (6 deals total)

  // timer display state (for base-timer circle)
  const [timeLeft, setTimeLeft] = useState(DEAL_MS); // ms left in the current 3s window
  const [tickId, setTickId] = useState(0); // increases each time a card is dealt (used to reset countdown)

  // refs for intervals/timeouts to clean up
  const dealIntervalRef = useRef(null);
  const countdownIntervalRef = useRef(null);
  const restartTimeoutRef = useRef(null);

  /** Start a fresh round and begin auto-dealing */
  function startRound() {
    // cleanup any prior timers
    clearInterval(dealIntervalRef.current);
    clearInterval(countdownIntervalRef.current);
    clearTimeout(restartTimeoutRef.current);

    setShoe((prev) => (prev.length < 10 ? shuffle(buildDeck()) : prev));
    setPlayerA([]);
    setPlayerB([]);
    setStep(0);
    setTimeLeft(DEAL_MS);
    setTickId((id) => id + 1);

    // 1) Deal a card every 3 seconds
    dealIntervalRef.current = setInterval(() => {
      setStep((prev) => prev + 1); // triggers the deal effect below
      setTickId((id) => id + 1); // resets countdown
      setTimeLeft(DEAL_MS);
    }, DEAL_MS);

    // 2) Countdown UI: update the circular timer ~10x/sec
    countdownIntervalRef.current = setInterval(() => {
      setTimeLeft((prev) => (prev <= 100 ? DEAL_MS : prev - 100));
    }, 100);
  }

  /** Perform deal on each step: 1→A, 2→B, 3→A, 4→B, 5→A, 6→B; auto-restart after 6 */
  useEffect(() => {
    if (step === 0) return;

    setShoe((prevShoe) => {
      if (prevShoe.length === 0) return prevShoe;

      const [top, ...rest] = prevShoe;

      // 👇 change is here: give first 3 cards to A, next 3 to B
      const dealToA = step <= 3;

      if (dealToA) setPlayerA((h) => [...h, top]);
      else setPlayerB((h) => [...h, top]);

      // after sixth deal, stop intervals and schedule a fresh round
      if (step === 6) {
        clearInterval(dealIntervalRef.current);
        clearInterval(countdownIntervalRef.current);
        setTimeLeft(0);
        restartTimeoutRef.current = setTimeout(() => {
          startRound();
        }, DEAL_MS); // wait 3s, then new round
      }
      return rest;
    });
  }, [step]);

  /** Auto-start once on mount */
  useEffect(() => {
    startRound();
    return () => {
      clearInterval(dealIntervalRef.current);
      clearInterval(countdownIntervalRef.current);
      clearTimeout(restartTimeoutRef.current);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  /** ---- SVG circular timer calculations ---- **/
  const R = 45; // circle r=45 (matches your SVG)
  const CIRC = 2 * Math.PI * R; // ~282.743
  const frac = Math.max(0, Math.min(1, timeLeft / DEAL_MS));
  const dash = Math.max(0.0001, CIRC * frac); // visible arc length
  const label = Math.ceil(timeLeft / 1000); // 3..2..1..

  // Winner confetti animation - trigger when new results arrive
  const lastResultIdRef = useRef(null);

  useEffect(() => {
    if (
      !payloadResult ||
      !Array.isArray(payloadResult) ||
      payloadResult.length === 0
    )
      return;

    const latestResult = payloadResult[0];
    const resultId =
      latestResult?._id || latestResult?.evt_id || JSON.stringify(latestResult);

    // Only fire if this is a new result
    if (lastResultIdRef.current === resultId) return;
    lastResultIdRef.current = resultId;

    const winResult = latestResult?.result;
    if (!winResult) return;

    //console.log("Firing confetti for result:", winResult);
    setWinnerText(`Winner: ${winResult}`);
    setShowWinnerOverlay(true);

    // Fire confetti after a tick so canvas is mounted
    setTimeout(() => {
      if (canvasRef.current) {
        const myConfetti = confetti.create(canvasRef.current, { resize: true });
        myConfetti({
          particleCount: 200,
          spread: 100,
          origin: { y: 0.5 },
          colors: [
            "#ff0000",
            "#00ff00",
            "#800080",
            "#ffff00",
            "#ff00ff",
            "#00bfff"
          ]
        });
      }
    }, 100);

    clearTimeout(winTimerRef.current);
    winTimerRef.current = setTimeout(() => {
      setShowWinnerOverlay(false);
      setWinnerText("");
    }, 4000);
  }, [payloadResult]);

  return (
    <div className="access-color bg-dream">
      <style>{`
        @media (max-width: 768px) {
          .color_prediction .btn-green > div:first-child,
          .color_prediction .btn-green-suspend > div:first-child,
          .color_prediction .btn-blue > div:first-child,
          .color_prediction .btn-red > div:first-child,
          .color_prediction .btn-red-suspend > div:first-child {
            display: flex !important;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            gap: 2px;
            white-space: nowrap;
          }
          .color_prediction .btn-green > div:first-child .fa-rocket,
          .color_prediction .btn-green-suspend > div:first-child .fa-rocket,
          .color_prediction .btn-blue > div:first-child .fa-rocket,
          .color_prediction .btn-red > div:first-child .fa-rocket,
          .color_prediction .btn-red-suspend > div:first-child .fa-rocket {
            font-size: 22px !important;
          }
          .color_prediction .btn-green,
          .color_prediction .btn-green-suspend {
            margin: 0 4px;
            position: relative;
            left: -10px;
          }
          .color_prediction .btn-blue {
            margin: 0 4px;
            position: relative;
            left: -9px;
          }
          .color_prediction .btn-red,
          .color_prediction .btn-red-suspend {
            margin: 0 4px;
            position: relative;
            left: -7px;
          }
          .color_prediction table {
            margin-bottom: 15px !important;
          }
          .color_prediction .btn-red,
          .color_prediction .btn-red-suspend {
            margin: 10px 10px 10px 4px !important;
          }
          .color_prediction .results-div .video-button {
            display: inline-block !important;
          }
        }
      `}</style>
      <div className="color_prediction">
        <ClientLayoutWithOutHeader showLoader={false}>
          <div className="details-tabs-wrapper1" style={{ border: "none" }}>
            <div className="main-page">
              <div className="row no-gutters">
                <div className="col-md-12">
                  <div className="bodyheight">
                    <div className="wrapper">
                      <TPStudioSidebar open={open} />
                    </div>

                    <div className="lobby-ctn BPGmaindiv">
                      <TpStudioHeader setOpen={setOpen} open={open} />
                      <TpStudioLoader displayLoader={displayLoader} />
                    </div>
                    <div
                      className="card ExMainCardbundle lobby-ctn BPGmaindiv"
                      style={{ border: "none" }}
                    >
                      <div
                        className="right-side-wrapper-row"
                        id="afterAnimation"
                        style={{ display: displayLoader ? "none" : "" }}
                      >
                        <div className="row right-side-row">
                          <div className="col-md-12 padding-none-wrapper1">
                            <div className="left-content">
                              <div className="table-wrap">
                                <div className="details-tabs-wrapper1">
                                  <div className="row">
                                    <div className="col-md-8">
                                      {/*- -*/}
                                      <div className="table-box-header2">
                                        <div className="row no-gutters">
                                          <div
                                            className="col-6"
                                            style={{ color: "white" }}
                                          >
                                            COLOR GAME
                                          </div>
                                          <div
                                            className="col-6"
                                            style={{
                                              color: "white",
                                              textAlign: "right"
                                            }}
                                          >
                                            <div
                                              role="group"
                                              aria-label="Second group"
                                              className="btn-group btn-group-sm mr-2"
                                            >
                                              <button
                                                type="button"
                                                id="Alltab"
                                                className={
                                                  activeTabIndex == 1
                                                    ? "tablink btn btn-primary bbactive"
                                                    : "tablink btn btn-primary"
                                                }
                                                onClick={() => activeTab(1)}
                                              >
                                                Game
                                              </button>
                                              <button
                                                type="button"
                                                id="RESULTStab"
                                                className={
                                                  activeTabIndex == 2
                                                    ? "tablink btn btn-primary bbactive"
                                                    : "tablink btn btn-primary"
                                                }
                                                onClick={() => activeTab(2)}
                                              >
                                                Results
                                              </button>
                                              <button
                                                type="button"
                                                className="tablink btn btn-primary"
                                              >
                                                Rules
                                              </button>
                                            </div>
                                          </div>
                                        </div>
                                      </div>

                                      {/*- -*/}
                                      <span
                                        id="AlltabData"
                                        style={{
                                          display:
                                            activeTabIndex == 1 ? "" : "none"
                                        }}
                                      >
                                        <div
                                          id="videos"
                                          className="collapse show"
                                          aria-labelledby="headingThree"
                                          data-parent="#video"
                                          style={{
                                            minHeight: 250,
                                            backgroundImage:
                                              "url(/assets/images/tpstudio/RouletteBg.webp)",
                                            backgroundRepeat: "round",
                                            textAlign: "center",
                                            padding: 0,
                                            border: "none",
                                            position: "relative"
                                          }}
                                        >
                                          <div
                                            className="row"
                                            style={{
                                              width: "100%",
                                              minHeight: 57
                                            }}
                                          >
                                            <div
                                              id="diceLastResult"
                                              style={{
                                                justifyContent: "center",
                                                width: "100%",
                                                display:
                                                  resultList.length > 0
                                                    ? "flex"
                                                    : "none"
                                              }}
                                            >
                                              <div
                                                className="alert  diceResultCls2"
                                                id="last_result_msg"
                                                style={{
                                                  padding: "0.35rem 1.25rem"
                                                }}
                                              >
                                                Last Result :{" "}
                                                {resultList.length > 0
                                                  ? resultList[0].result
                                                  : 0}
                                              </div>
                                            </div>
                                          </div>
                                          <div
                                            style={{
                                              margin: "0px auto",
                                              padding: "0 20px"
                                            }}
                                          >
                                            <table style={{ width: "100%" }}>
                                              <tbody>
                                                <tr>
                                                  <td
                                                    style={{
                                                      textAlign: "center",
                                                      display: "table-cell"
                                                    }}
                                                  >
                                                    <div
                                                      id="active_green"
                                                      className={`${
                                                        suspend1 == 1
                                                          ? "hides"
                                                          : ""
                                                      }`}
                                                    >
                                                      <button
                                                        className="btn-green"
                                                        data-teamname="green"
                                                        data-bettype="b"
                                                        style={{
                                                          fontSize: 15,
                                                          fontWeight: "bold",
                                                          border: 0
                                                        }}
                                                        onClick={() =>
                                                          showBetfairBetSlip(
                                                            "b",
                                                            "Green",
                                                            2
                                                          )
                                                        }
                                                      >
                                                        <div>
                                                          <i
                                                            className="fa fa-rocket"
                                                            aria-hidden="true"
                                                          />
                                                          <div>Join Green</div>
                                                        </div>
                                                        <div
                                                          id="b3"
                                                          className="odd"
                                                          style={{
                                                            display: "none"
                                                          }}
                                                        >
                                                          0
                                                        </div>
                                                      </button>
                                                      {/*-<div id="livestat3" style="color:red;">0</div>-*/}
                                                    </div>
                                                    <div
                                                      id="suspend_green"
                                                      className={`${
                                                        suspend1 == 1
                                                          ? ""
                                                          : "hides"
                                                      }`}
                                                    >
                                                      <button
                                                        className="btn-green-suspend"
                                                        style={{
                                                          fontSize: 15,
                                                          fontWeight: "bold"
                                                        }}
                                                      >
                                                        <div>
                                                          <i
                                                            className="fa fa-rocket"
                                                            aria-hidden="true"
                                                          />
                                                          <div>Join Green</div>
                                                        </div>
                                                      </button>
                                                    </div>
                                                  </td>
                                                  <td
                                                    style={{
                                                      textAlign: "center",
                                                      display: "table-cell"
                                                    }}
                                                  >
                                                    <div
                                                      id="active_blue"
                                                      className={`${
                                                        suspend1 == 1
                                                          ? "hides"
                                                          : ""
                                                      }`}
                                                    >
                                                      <button
                                                        className="btn-blue"
                                                        data-teamname="violet"
                                                        data-bettype="b"
                                                        style={{
                                                          fontSize: 15,
                                                          fontWeight: "bold",
                                                          border: 0
                                                        }}
                                                        onClick={() =>
                                                          showBetfairBetSlip(
                                                            "b",
                                                            "Violet",
                                                            "4.5"
                                                          )
                                                        }
                                                      >
                                                        <div>
                                                          <i
                                                            className="fa fa-rocket"
                                                            aria-hidden="true"
                                                          />
                                                          <div>Join Violet</div>
                                                        </div>
                                                        <div
                                                          id="b2"
                                                          className="odd"
                                                          style={{
                                                            display: "none"
                                                          }}
                                                        >
                                                          0
                                                        </div>
                                                      </button>
                                                    </div>
                                                    <div
                                                      id="suspend_blue"
                                                      className={`${
                                                        suspend1 == 1
                                                          ? ""
                                                          : "hides"
                                                      }`}
                                                    >
                                                      <button
                                                        className="btn-blue"
                                                        style={{
                                                          fontSize: 15,
                                                          fontWeight: "bold"
                                                        }}
                                                      >
                                                        <div>
                                                          <i
                                                            className="fa fa-rocket"
                                                            aria-hidden="true"
                                                          />
                                                          <div>Join Violet</div>
                                                        </div>
                                                      </button>
                                                    </div>
                                                  </td>
                                                  <td
                                                    style={{
                                                      textAlign: "center",
                                                      display: "table-cell"
                                                    }}
                                                  >
                                                    <div
                                                      id="active_red"
                                                      className={`${
                                                        suspend1 == 1
                                                          ? "hides"
                                                          : ""
                                                      }`}
                                                    >
                                                      <button
                                                        className="btn-red"
                                                        data-teamname="red"
                                                        data-bettype="b"
                                                        style={{
                                                          fontSize: 15,
                                                          fontWeight: "bold",
                                                          border: 0
                                                        }}
                                                        onClick={() =>
                                                          showBetfairBetSlip(
                                                            "b",
                                                            "Red",
                                                            2
                                                          )
                                                        }
                                                      >
                                                        <div>
                                                          <i
                                                            className="fa fa-rocket"
                                                            aria-hidden="true"
                                                          />
                                                          <div>Join Red</div>
                                                        </div>
                                                        <div
                                                          id="b1"
                                                          className="odd"
                                                          style={{
                                                            display: "none"
                                                          }}
                                                        >
                                                          0
                                                        </div>
                                                      </button>
                                                    </div>
                                                    <div
                                                      id="suspend_red"
                                                      className={`${
                                                        suspend1 == 1
                                                          ? ""
                                                          : "hides"
                                                      }`}
                                                    >
                                                      <button
                                                        className="btn-red-suspend"
                                                        style={{
                                                          fontSize: 15,
                                                          fontWeight: "bold"
                                                        }}
                                                      >
                                                        <div>
                                                          <i
                                                            className="fa fa-rocket"
                                                            aria-hidden="true"
                                                          />
                                                          <div>Join Red</div>
                                                        </div>
                                                      </button>
                                                    </div>
                                                  </td>
                                                </tr>
                                              </tbody>
                                            </table>
                                            <div
                                              id="card_list_1"
                                              className="color_prediction_cards"
                                            >
                                              <div className="selnumo">
                                                <ul style={{ display: "flex" }}>
                                                  <li>
                                                    <div
                                                      className={`active_number ${
                                                        suspend1 == 1
                                                          ? "hides"
                                                          : ""
                                                      }`}
                                                      onClick={() =>
                                                        showBetfairBetSlip(
                                                          "b",
                                                          "0",
                                                          9
                                                        )
                                                      }
                                                    >
                                                      <div
                                                        className="span1details"
                                                        style={{
                                                          cursor: "pointer"
                                                        }}
                                                        data-market-type="f"
                                                        data-teamname={0}
                                                        data-bettype="b"
                                                      >
                                                        <img src="/assets/images/bigsmall/parity0.png" />
                                                        <div
                                                          id="b4"
                                                          className="odd"
                                                          style={{
                                                            display: "none"
                                                          }}
                                                        >
                                                          0
                                                        </div>
                                                      </div>
                                                    </div>
                                                    <div
                                                      className={`suspend_number ${
                                                        suspend1 == 1
                                                          ? ""
                                                          : "hides"
                                                      }`}
                                                      style={{}}
                                                    >
                                                      <img src="/assets/images/bigsmall/parity0.png" />
                                                    </div>
                                                  </li>
                                                  <li>
                                                    <div
                                                      className={`active_number ${
                                                        suspend1 == 1
                                                          ? "hides"
                                                          : ""
                                                      }`}
                                                      onClick={() =>
                                                        showBetfairBetSlip(
                                                          "b",
                                                          "1",
                                                          9
                                                        )
                                                      }
                                                    >
                                                      <div
                                                        className="span1details"
                                                        style={{
                                                          cursor: "pointer"
                                                        }}
                                                        data-market-type="f"
                                                        data-teamname={1}
                                                        data-bettype="b"
                                                      >
                                                        <img src="/assets/images/bigsmall/parity1.png" />
                                                        <div
                                                          id="b5"
                                                          className="odd"
                                                          style={{
                                                            display: "none"
                                                          }}
                                                        >
                                                          0
                                                        </div>
                                                      </div>
                                                    </div>
                                                    <div
                                                      className={`suspend_number ${
                                                        suspend1 == 1
                                                          ? ""
                                                          : "hides"
                                                      }`}
                                                    >
                                                      <img src="/assets/images/bigsmall/parity1.png" />
                                                    </div>
                                                  </li>
                                                  <li>
                                                    <div
                                                      className={`active_number ${
                                                        suspend1 == 1
                                                          ? "hides"
                                                          : ""
                                                      }`}
                                                      onClick={() =>
                                                        showBetfairBetSlip(
                                                          "b",
                                                          "2",
                                                          9
                                                        )
                                                      }
                                                    >
                                                      <div
                                                        className="span1details"
                                                        style={{
                                                          cursor: "pointer"
                                                        }}
                                                        data-market-type="f"
                                                        data-teamname={2}
                                                        data-bettype="b"
                                                      >
                                                        <img src="/assets/images/bigsmall/parity2.png" />
                                                        <div
                                                          id="b6"
                                                          className="odd"
                                                          style={{
                                                            display: "none"
                                                          }}
                                                        >
                                                          0
                                                        </div>
                                                      </div>
                                                    </div>
                                                    <div
                                                      className={`suspend_number ${
                                                        suspend1 == 1
                                                          ? ""
                                                          : "hides"
                                                      }`}
                                                    >
                                                      <img src="/assets/images/bigsmall/parity2.png" />
                                                    </div>
                                                  </li>
                                                  <li>
                                                    <div
                                                      className={`active_number ${
                                                        suspend1 == 1
                                                          ? "hides"
                                                          : ""
                                                      }`}
                                                      onClick={() =>
                                                        showBetfairBetSlip(
                                                          "b",
                                                          "3",
                                                          9
                                                        )
                                                      }
                                                    >
                                                      <div
                                                        className="span1details"
                                                        style={{
                                                          cursor: "pointer"
                                                        }}
                                                        data-market-type="f"
                                                        data-teamname={3}
                                                        data-bettype="b"
                                                      >
                                                        <img src="/assets/images/bigsmall/parity3.png" />
                                                        <div
                                                          id="b7"
                                                          className="odd"
                                                          style={{
                                                            display: "none"
                                                          }}
                                                        >
                                                          0
                                                        </div>
                                                      </div>
                                                    </div>
                                                    <div
                                                      className={`suspend_number ${
                                                        suspend1 == 1
                                                          ? ""
                                                          : "hides"
                                                      }`}
                                                    >
                                                      <img src="/assets/images/bigsmall/parity3.png" />
                                                    </div>
                                                  </li>
                                                  <li>
                                                    <div
                                                      className={`active_number ${
                                                        suspend1 == 1
                                                          ? "hides"
                                                          : ""
                                                      }`}
                                                      onClick={() =>
                                                        showBetfairBetSlip(
                                                          "b",
                                                          "4",
                                                          9
                                                        )
                                                      }
                                                    >
                                                      <div
                                                        className="span1details"
                                                        style={{
                                                          cursor: "pointer"
                                                        }}
                                                        data-market-type="f"
                                                        data-teamname={4}
                                                        data-bettype="b"
                                                      >
                                                        <img src="/assets/images/bigsmall/parity4.png" />
                                                        <div
                                                          id="b8"
                                                          className="odd"
                                                          style={{
                                                            display: "none"
                                                          }}
                                                        >
                                                          0
                                                        </div>
                                                      </div>
                                                    </div>
                                                    <div
                                                      className={`suspend_number ${
                                                        suspend1 == 1
                                                          ? ""
                                                          : "hides"
                                                      }`}
                                                    >
                                                      <img src="/assets/images/bigsmall/parity4.png" />
                                                    </div>
                                                  </li>
                                                </ul>
                                                <ul style={{ display: "flex" }}>
                                                  <li>
                                                    <div
                                                      className={`active_number ${
                                                        suspend1 == 1
                                                          ? "hides"
                                                          : ""
                                                      }`}
                                                      onClick={() =>
                                                        showBetfairBetSlip(
                                                          "b",
                                                          "5",
                                                          9
                                                        )
                                                      }
                                                    >
                                                      <div
                                                        className="span1details"
                                                        style={{
                                                          cursor: "pointer"
                                                        }}
                                                        data-market-type="f"
                                                        data-teamname={5}
                                                        data-bettype="b"
                                                      >
                                                        <img src="/assets/images/bigsmall/parity5.png" />
                                                        <div
                                                          id="b9"
                                                          className="odd"
                                                          style={{
                                                            display: "none"
                                                          }}
                                                        >
                                                          0
                                                        </div>
                                                      </div>
                                                    </div>
                                                    <div
                                                      className={`suspend_number ${
                                                        suspend1 == 1
                                                          ? ""
                                                          : "hides"
                                                      }`}
                                                    >
                                                      <img src="/assets/images/bigsmall/parity5.png" />
                                                    </div>
                                                  </li>
                                                  <li>
                                                    <div
                                                      className={`active_number ${
                                                        suspend1 == 1
                                                          ? "hides"
                                                          : ""
                                                      }`}
                                                      onClick={() =>
                                                        showBetfairBetSlip(
                                                          "b",
                                                          "6",
                                                          9
                                                        )
                                                      }
                                                    >
                                                      <div
                                                        className="span1details"
                                                        style={{
                                                          cursor: "pointer"
                                                        }}
                                                        data-market-type="f"
                                                        data-teamname={6}
                                                        data-bettype="b"
                                                      >
                                                        <img src="/assets/images/bigsmall/parity6.png" />
                                                        <div
                                                          id="b10"
                                                          className="odd"
                                                          style={{
                                                            display: "none"
                                                          }}
                                                        >
                                                          0
                                                        </div>
                                                      </div>
                                                    </div>
                                                    <div
                                                      className={`suspend_number ${
                                                        suspend1 == 1
                                                          ? ""
                                                          : "hides"
                                                      }`}
                                                    >
                                                      <img src="/assets/images/bigsmall/parity6.png" />
                                                    </div>
                                                  </li>
                                                  <li>
                                                    <div
                                                      className={`active_number ${
                                                        suspend1 == 1
                                                          ? "hides"
                                                          : ""
                                                      }`}
                                                      onClick={() =>
                                                        showBetfairBetSlip(
                                                          "b",
                                                          "7",
                                                          9
                                                        )
                                                      }
                                                    >
                                                      <div
                                                        className="span1details"
                                                        style={{
                                                          cursor: "pointer"
                                                        }}
                                                        data-market-type="f"
                                                        data-teamname={7}
                                                        data-bettype="b"
                                                      >
                                                        <img src="/assets/images/bigsmall/parity7.png" />
                                                        <div
                                                          id="b11"
                                                          className="odd"
                                                          style={{
                                                            display: "none"
                                                          }}
                                                        >
                                                          0
                                                        </div>
                                                      </div>
                                                    </div>
                                                    <div
                                                      className={`suspend_number ${
                                                        suspend1 == 1
                                                          ? ""
                                                          : "hides"
                                                      }`}
                                                    >
                                                      <img src="/assets/images/bigsmall/parity7.png" />
                                                    </div>
                                                  </li>
                                                  <li>
                                                    <div
                                                      className={`active_number ${
                                                        suspend1 == 1
                                                          ? "hides"
                                                          : ""
                                                      }`}
                                                      onClick={() =>
                                                        showBetfairBetSlip(
                                                          "b",
                                                          "8",
                                                          9
                                                        )
                                                      }
                                                    >
                                                      <div
                                                        className="span1details"
                                                        style={{
                                                          cursor: "pointer"
                                                        }}
                                                        data-market-type="f"
                                                        data-teamname={8}
                                                        data-bettype="b"
                                                      >
                                                        <img src="/assets/images/bigsmall/parity8.png" />
                                                        <div
                                                          id="b12"
                                                          className="odd"
                                                          style={{
                                                            display: "none"
                                                          }}
                                                        >
                                                          0
                                                        </div>
                                                      </div>
                                                    </div>
                                                    <div
                                                      className={`suspend_number ${
                                                        suspend1 == 1
                                                          ? ""
                                                          : "hides"
                                                      }`}
                                                    >
                                                      <img src="/assets/images/bigsmall/parity8.png" />
                                                    </div>
                                                  </li>
                                                  <li>
                                                    <div
                                                      className={`active_number ${
                                                        suspend1 == 1
                                                          ? "hides"
                                                          : ""
                                                      }`}
                                                      onClick={() =>
                                                        showBetfairBetSlip(
                                                          "b",
                                                          "9",
                                                          9
                                                        )
                                                      }
                                                    >
                                                      <div
                                                        className="span1details"
                                                        style={{
                                                          cursor: "pointer"
                                                        }}
                                                        data-market-type="f"
                                                        data-teamname={9}
                                                        data-bettype="b"
                                                      >
                                                        <img src="/assets/images/bigsmall/parity9.png" />
                                                        <div
                                                          id="b13"
                                                          className="odd"
                                                          style={{
                                                            display: "none"
                                                          }}
                                                        >
                                                          0
                                                        </div>
                                                      </div>
                                                    </div>
                                                    <div
                                                      className={`suspend_number ${
                                                        suspend1 == 1
                                                          ? ""
                                                          : "hides"
                                                      }`}
                                                    >
                                                      <img src="/assets/images/bigsmall/parity9.png" />
                                                    </div>
                                                  </li>
                                                </ul>
                                              </div>
                                            </div>
                                            <div
                                              className="btn-group d-flex justify-content-center"
                                              style={{
                                                margin: "10px 0 0px 0px",
                                                paddingBottom: 15
                                              }}
                                            >
                                              <button
                                                type="button"
                                                className="btn gbtns btn1-clr span1details"
                                                data-market-type="f"
                                                data-teamname="Big"
                                                data-bettype="b"
                                                onClick={() =>
                                                  showBetfairBetSlip(
                                                    "b",
                                                    "Big",
                                                    2
                                                  )
                                                }
                                              >
                                                Big
                                                <div
                                                  id="b14"
                                                  className="odd"
                                                  style={{ display: "none" }}
                                                >
                                                  0
                                                </div>
                                              </button>
                                              <button
                                                type="button"
                                                className="btn gbtns btn2-clr span1details"
                                                data-market-type="f"
                                                data-teamname="Small"
                                                data-bettype="b"
                                                onClick={() =>
                                                  showBetfairBetSlip(
                                                    "b",
                                                    "Small",
                                                    2
                                                  )
                                                }
                                              >
                                                Small
                                                <div
                                                  id="b15"
                                                  className="odd"
                                                  style={{ display: "none" }}
                                                >
                                                  0
                                                </div>
                                              </button>
                                            </div>

                                            <div className="casino-timer">
                                              <svg
                                                className="progressBar"
                                                x="0px"
                                                y="0px"
                                                viewBox="0 0 80 80"
                                              >
                                                <path
                                                  className="track track_red"
                                                  d="M5,40a35,35 0 1,0 70,0a35,35 0 1,0 -70,0"
                                                />
                                                <path
                                                  className="fill fill_red"
                                                  d="M5,40a35,35 0 1,0 70,0a35,35 0 1,0 -70,0"
                                                  style={{
                                                    strokeDashoffset:
                                                      "-219.99078369140625"
                                                  }}
                                                />
                                                <text
                                                  className="value"
                                                  x="50%"
                                                  y="55%"
                                                >
                                                  {timeLeftGame}
                                                </text>
                                              </svg>
                                            </div>
                                            <div
                                              id="canvasVw"
                                              className={
                                                showWinnerOverlay ? "" : "hides"
                                              }
                                              style={{
                                                position: "absolute",
                                                top: 0,
                                                left: 0,
                                                width: "100%",
                                                height: "100%",
                                                zIndex: 10,
                                                pointerEvents: "none"
                                              }}
                                            >
                                              <div
                                                className="winnerResult"
                                                style={{
                                                  textAlign: "center",
                                                  padding: "5px 20px",
                                                  margin: "10px auto",
                                                  width: "fit-content"
                                                }}
                                              >
                                                {winnerText}
                                              </div>
                                              <canvas
                                                id="myCanvas"
                                                ref={canvasRef}
                                                style={{
                                                  position: "absolute",
                                                  top: 0,
                                                  left: 0,
                                                  width: "100%",
                                                  height: "100%"
                                                }}
                                              />
                                            </div>
                                            <Volume
                                              id="ColorGameSoundcontrol"
                                              style={{
                                                position: "absolute",
                                                right: 8,
                                                bottom: 8,
                                                zIndex: 100
                                              }}
                                            />
                                          </div>
                                        </div>

                                        {/*- -*/}
                                        <div className="row resultDiv">
                                          <div
                                            className="results-div"
                                            id="lastresults"
                                          >
                                            {resultList.map((val) => (
                                              <button className="video-button">
                                                {val.result}
                                              </button>
                                            ))}
                                          </div>
                                          <div className="round-div">
                                            <div className="label">
                                              Round ID:
                                            </div>{" "}
                                            <div id="round-id">{roundId}</div>
                                          </div>
                                        </div>
                                        {/*- -*/}
                                      </span>

                                      <span
                                        style={{
                                          display:
                                            activeTabIndex == 2 ? "" : "none"
                                        }}
                                      >
                                        <ColorGameResult
                                          resultData={resultList}
                                        />
                                      </span>
                                      <div
                                        id="ResultsData"
                                        className="tabcontent"
                                        style={{ display: "none" }}
                                      ></div>
                                    </div>
                                    <div className="col-md-4">
                                      <div
                                        className="accordion"
                                        id="bookmakerExample"
                                        style={{
                                          marginTop: 0,
                                          marginBottom: 5
                                        }}
                                      >
                                        <div
                                          className="card"
                                          style={{ border: 0 }}
                                        >
                                          <div
                                            id="casinoBetslipWeb"
                                            className="bets mob-hide"
                                            style={{ display: "none" }}
                                          >
                                            <strong>
                                              Bet Slip{" "}
                                              {/*-<a target="_blank" href="/Customer/Profile" class="button" style="color: white; float: right;">Edit Bet Sizes</a>-*/}
                                            </strong>
                                            <div className="betting-table">
                                              <table className="table">
                                                <thead>
                                                  <tr>
                                                    <th>Bet for</th>
                                                    <th>Odds</th>
                                                    <th>Stake</th>
                                                    <th>Profit</th>
                                                  </tr>
                                                </thead>
                                                <tbody>
                                                  <tr className="back bgColorBetslip">
                                                    <td>
                                                      <span id="divteamname_casino_web" />
                                                    </td>
                                                    <td width="10%">
                                                      <div className="quantity">
                                                        <input
                                                          type="text"
                                                          id="odd_casino_web"
                                                          name="odd_casino_web"
                                                        />
                                                        <div className="quantity-nav">
                                                          <div className="quantity-button quantity-up">
                                                            <span className="fa fa-caret-up" />
                                                          </div>
                                                          <div className="quantity-button quantity-down">
                                                            <span className="fa fa-caret-down" />
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </td>
                                                    <td width="10%">
                                                      <div className="stake">
                                                        <input
                                                          type="text"
                                                          id="casino_amount_web"
                                                          onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                                                        />
                                                      </div>
                                                    </td>
                                                    <td width="30%">
                                                      <span id="web_profit_div_web">
                                                        <span id="span_profit_casino_web">
                                                          0
                                                        </span>
                                                      </span>{" "}
                                                      <span id="span_profit_loss_gap">
                                                        / -
                                                      </span>{" "}
                                                      <span id="mobile_lib_div_web">
                                                        <span id="span_liability_casino_web">
                                                          0
                                                        </span>
                                                      </span>
                                                    </td>
                                                  </tr>
                                                  <tr className="back bgColorBetslip">
                                                    <td colSpan={5}>
                                                      <table
                                                        className="table"
                                                        style={{
                                                          backgroundColor:
                                                            "transparent"
                                                        }}
                                                      >
                                                        <tbody>
                                                          <tr className="checknow">
                                                            <td>
                                                              <span
                                                                className="points stake_btn_web"
                                                                onclick="set_btn_stake_casino_web(600)"
                                                              >
                                                                600
                                                              </span>
                                                            </td>
                                                            <td>
                                                              <span
                                                                className="points stake_btn_web"
                                                                onclick="set_btn_stake_casino_web(1000)"
                                                              >
                                                                1000
                                                              </span>
                                                            </td>
                                                            <td>
                                                              <span
                                                                className="points stake_btn_web"
                                                                onclick="set_btn_stake_casino_web(2000)"
                                                              >
                                                                2000
                                                              </span>
                                                            </td>
                                                            <td>
                                                              <span
                                                                className="points stake_btn_web"
                                                                onclick="set_btn_stake_casino_web(5000)"
                                                              >
                                                                5000
                                                              </span>
                                                            </td>
                                                          </tr>
                                                          <tr className="checknow"></tr>
                                                          <tr>
                                                            <td
                                                              style={{
                                                                padding: 1,
                                                                borderTop: 0
                                                              }}
                                                            >
                                                              <span
                                                                onclick="set_btn_stake_casino_web(1000)"
                                                                className="points"
                                                              >
                                                                +1,000
                                                              </span>
                                                            </td>
                                                            <td
                                                              style={{
                                                                padding: 1,
                                                                borderTop: 0
                                                              }}
                                                            >
                                                              <span
                                                                onclick="set_btn_stake_casino_web(5000)"
                                                                className="points"
                                                              >
                                                                +5,000
                                                              </span>
                                                            </td>
                                                            <td
                                                              style={{
                                                                padding: 1,
                                                                borderTop: 0
                                                              }}
                                                            >
                                                              <span
                                                                onclick="set_btn_stake_casino_web(10000)"
                                                                className="points"
                                                              >
                                                                +10,000
                                                              </span>
                                                            </td>
                                                            <td
                                                              style={{
                                                                padding: 1,
                                                                borderTop: 0
                                                              }}
                                                            >
                                                              <span
                                                                onclick="set_btn_stake_casino_web(25000)"
                                                                className="points"
                                                              >
                                                                +25,000
                                                              </span>
                                                            </td>
                                                          </tr>
                                                          <tr id="errorWebSlip">
                                                            <td
                                                              colSpan={4}
                                                              className="alert-danger pr-5"
                                                            />
                                                          </tr>
                                                          {/**/}
                                                          <tr>
                                                            <td>
                                                              <button
                                                                type="reset"
                                                                className="align-left btn btn-danger"
                                                                onclick="close_casino_betslip_web()"
                                                              >
                                                                <b>Close</b>
                                                              </button>
                                                            </td>
                                                            <td>
                                                              <button
                                                                type="reset"
                                                                className="align-left btn btn-warning"
                                                                onclick="close_casino_betslip_web()"
                                                              >
                                                                <b>Clear</b>
                                                              </button>
                                                            </td>
                                                            <td colSpan={1} />
                                                            <td>
                                                              <div
                                                                className="btn btn-primary ld-over"
                                                                style={{
                                                                  cursor:
                                                                    "pointer"
                                                                }}
                                                                id="btn_place_bet_casino_web"
                                                                name="btn_place_bet_casino_web"
                                                              >
                                                                <b>Submit</b>
                                                                <div className="ld ld-ball ld-flip" />
                                                              </div>
                                                            </td>
                                                          </tr>
                                                        </tbody>
                                                      </table>
                                                    </td>
                                                  </tr>
                                                </tbody>
                                              </table>
                                            </div>
                                          </div>
                                          <div
                                            className="card"
                                            style={{
                                              border: "0px",
                                              marginBottom: 0
                                            }}
                                          >
                                            <style>{`
        .new { width: 99%; height: 41px; font-size: 17px; }
        .bets>strong { background-color: var(--theme-color) !important; }
        .bets strong { display: block; background: #2b2f35; color: #fff; padding: 0 10px }
        .bets .betting-table { width: 100%; overflow-x: auto; max-height: 280px; overflow-y: auto }
        .bets input { width: 70px }
        .bets .table td { padding: 5px }
        .bets .points { display: block; background: #ccc; text-align: center; padding: 10px; margin: 2px; cursor: pointer }
        .back { background: #e9f6fc }
        .btn-primary { background-color: #00b181; border-color: #00b181 }
        .btn-primary:hover { background-color: #00b181; border-color: #00b181 }
        .van-stepper { display: flex; justify-content: space-between; align-items: center; width: 50% }
        button:focus { outline: none }
        @media only screen and (max-width: 768px) {
          .mob-hide { display: none !important; }
        }
        #refreshhistory .table thead th {
          padding: 5px;
          color: #2b2f35;
          background: #ddd;
      }
      `}</style>

                                            <div
                                              id="casinoBetslipPopup"
                                              className="bets mob-hide"
                                              style={{ display: "none" }}
                                            >
                                              <strong>Bet Slip</strong>

                                              <div
                                                className="betting-table"
                                                id="casinoBorderType"
                                              >
                                                <span
                                                  id="inputAmount"
                                                  style={{ display: "none" }}
                                                >
                                                  1
                                                </span>

                                                <table className="table">
                                                  <thead>
                                                    <tr>
                                                      <th>Bet for</th>
                                                      <th>Stake</th>
                                                      <th>Profit</th>
                                                    </tr>
                                                  </thead>

                                                  <tbody>
                                                    <tr className="back bgColorBetslip">
                                                      <td>
                                                        <span id="divteamname_casino"></span>
                                                      </td>

                                                      <td width="10%">
                                                        <div className="stake">
                                                          <input
                                                            type="text"
                                                            id="casino_amount"
                                                          />
                                                        </div>
                                                      </td>

                                                      <td width="30%">
                                                        <span id="div_profit_lib_casino">
                                                          <span id="span_profit_casino">
                                                            0
                                                          </span>
                                                        </span>
                                                        <span id="span_profit_loss_gap">
                                                          {" "}
                                                          / -{" "}
                                                        </span>
                                                        <span id="span_liability_casino">
                                                          0
                                                        </span>
                                                        <span id="mobile_lib_div_web">
                                                          <span id="span_liability_casino_web">
                                                            0
                                                          </span>
                                                        </span>
                                                      </td>
                                                    </tr>

                                                    <tr className="back bgColorBetslip">
                                                      <td colSpan="5">
                                                        <table
                                                          className="table"
                                                          style={{
                                                            backgroundColor:
                                                              "transparent"
                                                          }}
                                                        >
                                                          <tbody>
                                                            <tr className="checknow">
                                                              {[
                                                                200, 500, 1000,
                                                                2000, 5000
                                                              ].map((val) => (
                                                                <td
                                                                  key={val}
                                                                  style={{
                                                                    padding:
                                                                      "1px",
                                                                    borderTop:
                                                                      "0px"
                                                                  }}
                                                                >
                                                                  <span
                                                                    className="btn_bet points"
                                                                    style={{
                                                                      width:
                                                                        "99%",
                                                                      height:
                                                                        "41px",
                                                                      fontSize:
                                                                        "17px"
                                                                    }}
                                                                    id={`btn_bet_${val}`}
                                                                  >
                                                                    {val}
                                                                  </span>
                                                                </td>
                                                              ))}
                                                              <input
                                                                type="hidden"
                                                                id="btn_stake_value"
                                                                value="200"
                                                              />
                                                            </tr>

                                                            <tr>
                                                              <td colSpan="5">
                                                                <span id="betalert_casino"></span>
                                                              </td>
                                                            </tr>

                                                            <tr>
                                                              <td>
                                                                <button
                                                                  type="reset"
                                                                  className="btn btn-danger"
                                                                >
                                                                  <b>Close</b>
                                                                </button>
                                                              </td>
                                                              <td>
                                                                <button
                                                                  type="reset"
                                                                  className="btn btn-warning"
                                                                >
                                                                  <b>Clear</b>
                                                                </button>
                                                              </td>
                                                              <td></td>
                                                              <td>
                                                                <div
                                                                  className="btn btn-primary ld-over"
                                                                  id="btn_place_bet_casino"
                                                                >
                                                                  <b>Submit</b>
                                                                  <div className="ld ld-ball ld-flip"></div>
                                                                </div>
                                                              </td>
                                                            </tr>
                                                          </tbody>
                                                        </table>
                                                      </td>
                                                    </tr>
                                                  </tbody>
                                                </table>
                                              </div>
                                            </div>
                                            {showBetSlipPopup && (
                                              <TPPopUpBetSlip
                                                closeBetSlipParent={
                                                  closeBetSlipMobile
                                                }
                                                betObj={placeBetObject}
                                                placeBetParent={placeBet}
                                                betButtonShow={betButtonShow}
                                                betErrorMessageObj={
                                                  betErrorMessageObj
                                                }
                                                betButtonShowLoaderShow={
                                                  betButtonShowLoaderShow
                                                }
                                                profileData={profileData}
                                              />
                                            )}

                                            <BetfairCasinoBetslipWeb
                                              showBetSlip={showBetSlip}
                                              placeBetObject={placeBetObject}
                                              closeBetSlipParent={closeBetSlip}
                                              placeBetParent={placeBet}
                                              betErrorMessageObj={
                                                betErrorMessageObj
                                              }
                                            ></BetfairCasinoBetslipWeb>
                                            <div
                                              className="card-header"
                                              style={{
                                                padding: "0px",
                                                background: "#23292d"
                                              }}
                                            >
                                              <h2
                                                className="mb-0"
                                                style={{
                                                  background:
                                                    "var(--theme-color)"
                                                }}
                                              >
                                                <button
                                                  className="btn btn-link btn-block text-left"
                                                  style={{
                                                    color: "white",
                                                    textDecoration: "none"
                                                  }}
                                                >
                                                  My Bets
                                                </button>
                                              </h2>
                                            </div>

                                            <div
                                              className="collapse show"
                                              style={{
                                                backgroundColor: "#2e3438"
                                              }}
                                            >
                                              <div
                                                className="card-body"
                                                style={{ padding: 0 }}
                                              >
                                                <div
                                                  className="table-responsive"
                                                  id="refreshhistory"
                                                >
                                                  <table
                                                    className="table"
                                                    style={{ marginBottom: 0 }}
                                                  >
                                                    <thead>
                                                      <tr>
                                                        <th>Runner</th>
                                                        <th>Type</th>
                                                        <th>Size</th>
                                                        <th></th>
                                                      </tr>
                                                    </thead>
                                                    <tbody>
                                                      {betList.length > 0 ? (
                                                        betList.map(
                                                          (item, index) => (
                                                            <tr
                                                              style={{
                                                                background:
                                                                  item.type ==
                                                                  "b"
                                                                    ? "#e9f6fc"
                                                                    : "#fce3e4",
                                                                color: "#000",
                                                                fontSize:
                                                                  "15px",
                                                                textAlign:
                                                                  "center"
                                                              }}
                                                            >
                                                              <td
                                                                style={{
                                                                  textAlign:
                                                                    "left",
                                                                  padding:
                                                                    "15px",
                                                                  display:
                                                                    "table-cell",
                                                                  padding: "5px"
                                                                }}
                                                              >
                                                                {item.rnr}-{" "}
                                                                {item.cat_mid}
                                                              </td>
                                                              <td
                                                                style={{
                                                                  display:
                                                                    "table-cell",
                                                                  textAlign:
                                                                    "left",
                                                                  padding: "5px"
                                                                }}
                                                              >
                                                                {item.bet_type}
                                                              </td>
                                                              <td
                                                                style={{
                                                                  display:
                                                                    "table-cell",
                                                                  textAlign:
                                                                    "left",
                                                                  padding: "5px"
                                                                }}
                                                              >
                                                                {item.amnt}
                                                              </td>
                                                              <td></td>
                                                            </tr>
                                                          )
                                                        )
                                                      ) : (
                                                        <tr></tr>
                                                      )}
                                                    </tbody>
                                                  </table>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                        {/* Open bets end*/}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ClientLayoutWithOutHeader>
      </div>
    </div>
  );
}
